import React from 'react';
import PageHeader from '../../components/PageHeader';

const AddUserHeader: React.FC = () => (
  <PageHeader title="Add New User" linkText="Return to users list" linkAddress="/" />
);

export default AddUserHeader;
